import {
  getAvailableSegment as coreGetAvailableSegment,
  getAvailableSegments as coreGetAvailableSegments,
} from '@revelio/core';

import type { PrimaryFilterId } from '../../../filters/types/filters';
import type { ChartType } from '../../PageConfigProvider/types/chart';
import type { MetricValues } from '../../PageConfigProvider/types/metric';
import { PRIMARY_FILTER_TO_ENTITY_TYPE } from './metric-mapping';

type GetAvailableSegmentProps = {
  chartType?: ChartType;
  primaryFilterId: PrimaryFilterId;
  metric?: MetricValues;
};

export const getAvailableSegment = ({
  chartType,
  primaryFilterId,
  metric,
}: GetAvailableSegmentProps) => {
  const entityType = PRIMARY_FILTER_TO_ENTITY_TYPE[primaryFilterId];
  if (!entityType) return [];
  return coreGetAvailableSegment({ entityType, chartType, metric });
};

type GetAvailableSegmentsProps = Omit<GetAvailableSegmentProps, 'metric'> & {
  metrics?: MetricValues[];
};

export const getAvailableSegments = ({
  chartType,
  primaryFilterId,
  metrics,
}: GetAvailableSegmentsProps) => {
  const entityType = PRIMARY_FILTER_TO_ENTITY_TYPE[primaryFilterId];
  if (!entityType) return [];
  return coreGetAvailableSegments({ entityType, chartType, metrics });
};
